import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 400px;
  padding: 72px 0 80px;
  background-color: ${COLORS.black};
`;

export default Wrapper;
